import React from 'react';
import { ButtonGroup, Button } from 'reactstrap';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import styled from 'styled-components';
import ActionIcon from '../../../components/custom/ActionIcon';
import BackButton from '../../../components/custom/BackButton';
import useUnit from '../../../customHooks/useUnit';
import { ChoiceEmployee, IUser } from '../../../globals/interfaces';
import { Environments } from '.';

interface Props {
    modal: boolean;
    setModal: (state: boolean) => void;
    environments: Environments;
    employee: ChoiceEmployee | undefined;
    updateUserEnvironment: (environment: string) => Promise<void>;
}

export default function ModalUser({
    modal,
    setModal,
    environments,
    employee,
    updateUserEnvironment
}: Props) {

    const toggle = () => setModal(!modal);

    if (!environments || !employee) return null;

    return (
        <Modal isOpen={modal} toggle={toggle}>
            <ModalHeader className={'d-flex'}>
                <HeaderContainer>
                    <BackButton onClick={toggle} />
                    <h4 className={'pl-2'}>Select EOS Environment for {employee.s_first_name} {employee.s_last_name}</h4>
                </HeaderContainer>
            </ModalHeader>
            <ModalBody className={'mx-auto'}>
                <ButtonGroup>
                    {
                        environments.map((item, i) => (
                            <Button
                                key={i}
                                active={employee.s_environment === item.name}
                                onClick={() => updateUserEnvironment(item.name)}
                            >
                                {item.name}
                            </Button>
                        ))
                    }
                </ButtonGroup>
            </ModalBody>
        </Modal>
    );
}

const HeaderContainer = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
`;

const ExpandedFooter = styled(ModalFooter)`
    width: 100%;
`;

const FooterContentContainer = styled.div`
    width: 100%;
`;

const FooterButtonsContainer = styled.div<{ update?: boolean }>`
    width: 100%;
    display: flex;
    justify-content: ${p => p.update ? 'space-between' : 'flex-end'};
`;